import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['settings', 'user'])
}



// WEBPACK FOOTER //
// ./src/app/professional/config/resources/computed.js